import React, {Fragment, useEffect} from 'react';
import TableHead from '@mui/material/TableHead';
import MaterialTable from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Row from './Row';
import {connect} from 'react-redux';
import TableFooter from '@mui/material/TableFooter';
import {useTranslation} from 'react-i18next';
import Empty from './Empty';
import Pagination from '../../../data/table/Pagination';
import {
	fetchSegments,
	setSegmentsFilters,
	setSegmentsPaging
} from '../../../../../store/actions/MassMailAction';


const Table = ({
	               realmId,
	               segments,
	               fetch,
	               setSegmentsFilters,
	               setSegmentsPaging,
	               loading,
	               filters,
	               paging,
	               count,
	               disabled = false
               }) => {
	const loadingData = [...Array(paging.results_per_page).keys()];

	const displayLoading = () => loadingData.map((k) => <Row key={k} loading={true} segment={null}/>);
	const displaySegments = () => segments.map((o) => <Row key={o.Network_MassMail_Segment__} loading={false} segment={o}/>);
	const {t} = useTranslation();

	useEffect(() => {
		if (!disabled) fetch(realmId);
	}, [realmId, disabled, fetch, filters, paging]);


	return (
		<Fragment>
			{(loading || segments.length > 0) &&
			<TableContainer>
				<MaterialTable aria-label="simple table">
					<TableHead>
						<TableRow>
							<Pagination
								setPaging={setSegmentsPaging}
								paging={paging}
								loading={loading}
								count={count}
							/>
						</TableRow>
						<TableRow>
							<TableCell>{t('massmail_segments_visible')}</TableCell>
							<TableCell>{t('massmail_segments_name')}</TableCell>
							<TableCell>{t('massmail_segments_email')}</TableCell>
							<TableCell align='right'/>
						</TableRow>
					</TableHead>
					<TableBody>
						{(loading || disabled) && displayLoading()}
						{(!loading && !disabled) && displaySegments()}
					</TableBody>
					<TableFooter>
						<TableRow>
							<Pagination
								setPaging={setSegmentsPaging}
								paging={paging}
								loading={loading}
								count={count}
							/>
						</TableRow>
					</TableFooter>

				</MaterialTable>
			</TableContainer>
			}
			{(!loading && segments.length < 1) && <Empty/>}
		</Fragment>
	);
};


const mapStateToProps = (state) => {
	return {
		filters: state.massMail.segmentsFilters,
		paging: state.massMail.segmentsPaging,
		count: state.massMail.segmentsPagingCount,
		loading: state.massMail.segmentsLoading,
		segments: state.massMail.segments
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetch: (realmId) => dispatch(fetchSegments(realmId)),
		setSegmentsFilters: (filters) => dispatch(setSegmentsFilters(filters)),
		setSegmentsPaging: (paging) => dispatch(setSegmentsPaging(paging))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);

